<div class="header">
  <div class="header-left-side">
    <div class="header-logo-container">
      <img
        [src]="headerLogoConfig.img"
        [alt]="headerLogoConfig.alt"
        class="header-logo"
        (click)="goHome()"
      />
    </div>
    <div class="vertical-line-container">
      <div class="header-vertical-line"></div>
    </div>
    <div class="header-titles-container">
      @if (contextMode === "upload-files") {
        <p class="header-title">
          {{ "Càrrega dades recuperades" | translate }}
        </p>
      } @else {
        <p class="header-title">
          {{ gencatHeaderConfig.titleHead | translate }}
        </p>
        <p class="header-subtitle">
          {{ gencatHeaderConfig.subtitleHead ?? "" | translate }}
        </p>
      }
    </div>
  </div>
  @if (contextMode === "default") {
    <div class="header-right-side">
      <div class="header-user-dropdown-icons-container">
        <app-header-user />
        <app-header-notifications />
      </div>
    </div>
  }
</div>
